// outer IIFE to make sure each shared component can define its own isNodeJs.
// isNodeJs is scoped to the outer IIFE this way
(function () {

  // tests available under server/test/moduleHelper
  class AreaInheritanceHelpers {
    constructor(options) {
      Object.assign(this, options);

      // @ts-ignore
      this.optionsMapping = {
        displayNameKey: ['prefix', 'value'],
        valueKey: 'value'
      };
    }

    overwriteBasicAreaElements(filterModules, areaId, basicAreaId, project) {
      return filterModules.map((module) => {
        module.submodules = module.submodules.map((submodule) => {

          // We cannot simply filter on constructionId:
          // When we are retrieving an area we want a fallback to the basicArea element
          submodule.elements = submodule.elements.reduce((array, element) => {
            if (!element.active) {
              return array;
            }

            // Check if we already have a duplicate element in our return array
            const duplicateIndex = array.findIndex((elem) => (
              elem._id === element.basicAreaElementId ||
              elem.basicAreaElementId === element._id
            ));

            // We already have a duplicate, however our new item takes precedence because
            // it matches our requested constructionId
            if (duplicateIndex > -1 && element.constructionId === areaId) {

              // If we are certain our duplicate index is the basicArea element of our current element,
              // enhance our current element with the basicAreaValue
              if (array[duplicateIndex].projectLevel === 4 && array[duplicateIndex].constructionId === basicAreaId) {
                element.basicAreaValue = array[duplicateIndex].value;
              }

              // Now overwrite the basicAreaElement with our areaElement
              array[duplicateIndex] = element;

              // Here we are certain our current element is the basicAreaElement of the duplicateIdx
            } else if (duplicateIndex > -1 && element.projectLevel === 4 && element.constructionId === basicAreaId) {
              array[duplicateIndex].basicAreaValue = element.value;

              // We do not have a duplicateIdx yet, we have an element that is part of our requested area or
              // our requested area's basicArea
            } else if (element.constructionId === areaId || element.constructionId === basicAreaId) {
              array.push(element);
            }
            return array;
          }, []);

          // TODO perhaps all these element enhancements should be done in an own function
          // Enhance elements with basicAreaValue and templateValues
          submodule.elements = submodule.elements.map((elem) => {
            elem.options = this.getOptions(elem);
            // @ts-ignore
            elem.optionsMapping = this.optionsMapping;
            // @ts-ignore
            elem.filter = this.sgAutocompleteHelpers.filter;
            elem.sgInputType = this.getSgInputType(elem);
            elem.model = this.findOption(elem);
            elem.tinyMceOptions = this.setTinyMceOptions(elem, project);
            elem.originalValue = elem.basicAreaValue || elem.value;
            return elem;
          });
          return submodule;
        });
        return module;
      });
    };

    getOptions(element) {
      const suggestions = [];

      if (element.basicAreaValue && element.projectLevel === 5) {
        suggestions.push({
          // @ts-ignore
          prefix: `${this.Labels.getLabel('areatemplatevalue')}: `,
          value: element.basicAreaValue,
          bold: true
        });
      }

      if (!element.templateValues) {
        element.templateValues = [];
      }
      
      element.templateValues.forEach((val) => suggestions.push({
        // @ts-ignore
        prefix: `${this.Labels.getLabel('templatevalue')} (${this.qualityDisplayName(val)}):`,
        value: val.value,
        bold: true
      }));

      if (element.inputType === 'Select') {
        element.selectOptions.forEach((opt) => opt.active && suggestions.push({
          // here we use name as the value. We should not be able to change this later on. (unlike libElements)
          // @ts-ignore
          prefix: `${ this.Labels.getLabel('option') }:`,
          value: opt.name
        }));
        // suggestions.push({ prefix: this.Labels.getLabel('addoption'), value: '+' });
      }

      return suggestions;
    };

    /**
     * Set input type for combobox and inline edit.
     *
     * @param element Element to check.
     * @returns Combobox or inline edit type.
     */
    getSgInputType(element) {
      if (element.inputType === 'Select') {
        return 'sg-combobox-dropdown';
      } else if (element.options.length > 1) {
        return 'sg-combobox-suggestions';
      }
      return 'sg-inline-edit';
    };

    findOption(element) {
      if (element.value === undefined || element.value === '' || element.value === null) {
        return undefined;
      }
      return element.options.find((option) => option.value === element.value);
    }

    qualityDisplayName(valueObj) {
      // @ts-ignore
      const ql = this.Constants.getList('QUALITY_LEVELS').find((quality) => quality.value === valueObj.quality);
      if (ql) {
        return ql.displayName;
      } else if (valueObj.quality === 'sourceProject') {
        // @ts-ignore
        return this.Labels.getLabel('projectsourcevalue');
      }

      return '';
    }

    setTinyMceOptions(elem, project) {
      if (elem.projectLevel < 4 || elem.inputType !== 'Long String') {
        return null;
      }

      const canWriteOpts = {
        project,
        projectLevels: ['manager', 'contributor']
      };

      // @ts-ignore
      return this.EditorConfig({
        contentLanguage: project.language,
        inline: true,
        element: elem,
        // @ts-ignore
        readonly: !this.Utils.canWriteProject(this.Auth.getCurrentUser(), canWriteOpts),
      });
    };
  }


  const {TranslateHelpers} = require('./translate.helpers');
  // const labels = require('../../server/labels.json');
  const labels = {};

  exports.AreaInheritanceHelper = new AreaInheritanceHelpers({
    sgAutocompleteHelpers: {},
    Constants: {},
    Labels: new TranslateHelpers({
      labels,
      languageFn: () => 'nl',
    }),
    EditorConfig: () => ({}),
    Utils: {
      canWriteProject: () => {
      },
    },
    Auth: {
      getCurrentUser: () => {
      },
    }
  });


})
();
